import styled from 'styled-components';

export const PlaybacksText = styled.div`
  padding-left: 5px;
  color: #0099d8;
  font-size: ${props => props.theme.sizes.S};
  font-weight: ${props => props.theme.fontWeights.regular};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  border: 1px solid #0099d8;
  padding: 1px 5px;
  border-radius: 4px;
  position: absolute;
  right: 0;
  top: 0;
`;
